import {defineMessage} from "react-intl";

export const LogoutMessage = defineMessage({
  id: "logout.title",
  defaultMessage: "Log out",
})
